module.exports = __webpack_public_path__ + "static/assets/bbb6b25ae7fae81e59ccc8be3c919f99.svg";